module.exports = __webpack_public_path__ + "img/17.6eb840c5.webp";